document.addEventListener("DOMContentLoaded", function () {
  const counters = document.querySelectorAll(".study-numbers");

  const animateCounter = (el) => {
    const originalText = el.textContent.trim();

    // Extract number and suffix (%, +, etc)
    const numberMatch = originalText.match(/\d+/);
    if (!numberMatch) return;

    const target = parseInt(numberMatch[0], 10);
    const suffix = originalText.replace(target, "");

    let current = 0;
    const duration = 300;
    const stepTime = Math.max(Math.floor(duration / target), 10);

    const timer = setInterval(() => {
      current++;
      el.textContent = current + suffix;

      if (current >= target) {
        el.textContent = target + suffix;
        clearInterval(timer);
      }
    }, stepTime);
  };

  // Intersection Observer
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );

  counters.forEach(counter => observer.observe(counter));
});